/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckPaxSession } from './PaxCheckPaxSession';
import {
    PaxCheckPaxSessionFromJSON,
    PaxCheckPaxSessionFromJSONTyped,
    PaxCheckPaxSessionToJSON,
    PaxCheckPaxSessionToJSONTyped,
} from './PaxCheckPaxSession';

/**
 * 
 * @export
 * @interface PaxCheckAddAddressResult
 */
export interface PaxCheckAddAddressResult {
    /**
     * 
     * @type {PaxCheckPaxSession}
     * @memberof PaxCheckAddAddressResult
     */
    updatedPaxSession: PaxCheckPaxSession;
}

/**
 * Check if a given object implements the PaxCheckAddAddressResult interface.
 */
export function instanceOfPaxCheckAddAddressResult(value: object): value is PaxCheckAddAddressResult {
    if (!('updatedPaxSession' in value) || value['updatedPaxSession'] === undefined) return false;
    return true;
}

export function PaxCheckAddAddressResultFromJSON(json: any): PaxCheckAddAddressResult {
    return PaxCheckAddAddressResultFromJSONTyped(json, false);
}

export function PaxCheckAddAddressResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckAddAddressResult {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedPaxSession': PaxCheckPaxSessionFromJSON(json['updated_pax_session']),
    };
}

export function PaxCheckAddAddressResultToJSON(json: any): PaxCheckAddAddressResult {
    return PaxCheckAddAddressResultToJSONTyped(json, false);
}

export function PaxCheckAddAddressResultToJSONTyped(value?: PaxCheckAddAddressResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updated_pax_session': PaxCheckPaxSessionToJSON(value['updatedPaxSession']),
    };
}

